import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './Profile.sass'
import ViewController from 'ViewController'
import ProfileNav from './ProfileNav'
import { Route, RouteChildrenProps, Redirect } from 'react-router'
import General from './General'
import Billing from './Billing'
import Notifications from './Notifications'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import { SplitView, SplitViewSide, SplitViewMain } from 'components/SplitView'
import ScrollView from 'components/ScrollView'
import link from 'infra/link'

interface ProfileProps extends RouteChildrenProps {
  viewController: ViewController
}

export default observer(function Profile({
  match,
  viewController,
}: ProfileProps) {
  const vm = viewController.profileViewModel
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  return (
    <div className={cx(styles.root)}>
      <SplitView>
        <SplitViewSide>
          <ProfileNav vm={vm} />
        </SplitViewSide>
        <SplitViewMain>
          <ScrollView ref={scrollRef}>
            <Route path={`/profile/payouts/method`} exact>
              <Redirect push={false} to={link.profileBillingPayoutMethod()} />
            </Route>
            <Route path={link.profile()} exact>
              <Redirect push={false} to={`${match?.url}/general`} />
            </Route>
            <Route path={link.profileBilling()} exact>
              <Redirect push={false} to={link.profileBillingPaymentMethods()} />
            </Route>
            <Route path={link.profileGeneral()}>
              <General vm={vm} scrollOffset={scrollOffset} />
            </Route>
            <Route
              path={link.profileBilling()}
              render={(props) => {
                return vm.shouldShowBilling ? (
                  <Billing {...props} vm={vm} scrollOffset={scrollOffset} />
                ) : (
                  <Redirect push={false} to={link.profileGeneral()} />
                )
              }}
            ></Route>
            <Route path={link.profileNotifications()}>
              <Notifications vm={vm} scrollOffset={scrollOffset} />
            </Route>
          </ScrollView>
        </SplitViewMain>
      </SplitView>
    </div>
  )
})
